import * as React from "react";
import { SVGProps, memo } from "react";
const SvgVirtualConnectionTableExtract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#BFBFBF" d="M13 7v1h2v1h-2v1h-1V9h-1V8h1V7h1ZM3 5v1H1V5h2Z" />
      <path
        fill="#666"
        d="M6 10h9V7h-4V6h4V5H7v1H6V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H8v1.086c.436.154.778.502.924.941L8.914 13 14 13v1H8.914l.008-.022a1.5 1.5 0 0 1-2.796.124l-.04-.101L2 14v-1l4.086-.001-.01.028c.146-.439.489-.788.924-.942V11a1 1 0 0 1-1-1Zm3-9a1 1 0 0 1 1 1v1H9V2H1v1h2v1H1v3h2v1H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8Z"
      />
      <path
        fill="#666"
        d="M7.5 13a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zM5 4v1c0 1.44.46 1.958 1.825 1.998L7 7h1V5.811a.25.25 0 0 1 .03-.117l.034-.05a.25.25 0 0 1 .298-.056l.055.038 1.895 1.707a.25.25 0 0 1 .025.302l-.043.05-1.877 1.69a.25.25 0 0 1-.41-.129L8 9.189V8H7c-1.929 0-2.927-.93-2.996-2.79L4 5V4h1z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgVirtualConnectionTableExtract);
export default Memo;
